// eslint-disable-next-line no-unused-vars
function annualize(value, fiscalYearEndDate, throughDate) {
  const efy = Date.parse(fiscalYearEndDate)
  const remaining = efy - Date.parse(throughDate)
  const days = (365 - Math.trunc(remaining / (1000 * 60 * 60 * 24)))
  const annualized = (365/days) * value
  return Math.round(annualized)
}

// eslint-disable-next-line no-unused-vars
function currencyFormat(currency) {
  return '$' + String(Math.trunc(currency)).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

// eslint-disable-next-line no-unused-vars
function ifUndefined(value, text, expression) {
  let values = value
  if (!Array.isArray(value)) {
    values = [value]
  }
  for (let value of values) {
    if (value === undefined) {
      return text
    }
  }
  return expression
}

export const addValues = function addValues(values) {
  Object.assign(this, values)
}

export const evaluateText = function evaluateText(text) {
  if (text === undefined) {
    return text
  }
  const target = '`' + text + '`'
  try {
    // eslint-disable-next-line no-eval
    const newText = eval(target)
    return newText
  } catch (err) {
    console.log(`ERROR evaluateText ${err.message} "${target}`)
    return `Formula error: ${err.message}`
  }
}
